// src/getEnvConfig.ts
function getEnvConfig(key) {
  var _a;
  const _window = globalThis.window;
  if (_window == null ? void 0 : _window.env) {
    return _window.env[key];
  }
  if ((_a = globalThis.process) == null ? void 0 : _a.env) {
    return globalThis.process.env[key];
  }
}

export {
  getEnvConfig
};
